var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgUserFollowFill = function SvgUserFollowFill(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 25 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M13.4 13.857v7.145H5.3a7.2 7.2 0 0 1 8.1-7.145m-.9-.955a5.4 5.4 0 0 1-5.4-5.4c0-2.984 2.417-5.4 5.4-5.4s5.4 2.416 5.4 5.4c0 2.983-2.416 5.4-5.4 5.4m5.214 6.222 3.181-3.181 1.274 1.272-4.455 4.455-3.183-3.182 1.274-1.273z"
  })));
};
export default SvgUserFollowFill;